// extracted by mini-css-extract-plugin
export default {"link":"HomeCard_link__4ctJ0","container":"HomeCard_container__OOg5f","iconStyle":"HomeCard_iconStyle__Ugp4C","text":"HomeCard_text__4+agp"};